module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('dashboard', {
    staticClass: "scaledDashboard",
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": "t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC"
    }
  }), _vm._v(" "), _c('graph', {
    staticClass: "scaledGraph",
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": "t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('h1', [_vm._v("HARVEST PROJECTION ENDPOINT")]), _vm._v(" "), _c('p', [_vm._v("\n      This is the endpoint of the realtime projection for Julian Olivers "), _c('a', {
    attrs: {
      "href": "https://julianoliver.com/output/harvest",
      "target": "_blank"
    }
  }, [_vm._v("HARVEST")]), _vm._v(" installation.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      There are 2 views: "), _c('a', {
    attrs: {
      "href": "#/vis/t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC/graph"
    }
  }, [_vm._v("hashrate history")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "#/vis/t1YR6ihrgmWWGp4kDjyeXRpbUgEUzmFDSVC/dashboard"
    }
  }, [_vm._v("dashboard")]), _vm._v(" both are optimized for full hd. To display your own miner just change the ZEC address in the url to yours. You can find the source code on "), _c('a', {
    attrs: {
      "href": "https://github.com/cpietsch/harvest",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      APIs used: "), _c('a', {
    attrs: {
      "href": "https://zec.nanopool.org/api",
      "target": "_blank"
    }
  }, [_vm._v("Nanopool")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://min-api.cryptocompare.com",
      "target": "_blank"
    }
  }, [_vm._v("Cryptocompare")])]), _vm._v(" "), _c('p', [_vm._v("\n      Created by "), _c('a', {
    attrs: {
      "href": "https://chrispie.com",
      "target": "_blank"
    }
  }, [_vm._v("Christopher Pietsch")]), _vm._v(" 2017-2018\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44540a1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 790
// module chunks = 1